import { Component, OnInit } from "@angular/core";
import { OTScheduleService } from "../../shared/services/ot-schedule/ot-schedule.service";
import { Subject } from "rxjs";
import { debounceTime, first } from "rxjs/operators";
import { Router } from "@angular/router";
import { AlertService } from "../../shared/services/alert/alert.service";

@Component({
  selector: 'app-upload-ot-schedule',
  templateUrl: './upload-ot-schedule.component.html',
  styleUrls: ['./upload-ot-schedule.component.scss']
})
export class UploadOtScheduleComponent implements OnInit {

  fileType: any =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  dataAvailable = false;
  dataCount: any;
  uploadType: any = "import";
  error: any;
  private _success = new Subject<string>();
  private _error = new Subject<string>();
  errorMessage: any = null;
  successMessage: any = null;
  otScheduledata: any = [];
  errorCount = 0;


  constructor(
    private otScheduleService: OTScheduleService,
    private router: Router,
    private alertService: AlertService
  ) { }

  sender = "upload-ot-schedule";


  ngOnInit() {
    this.initAlert();
  }

  ondocImport(e: any) {
    this.otScheduledata = e;
    if (this.otScheduledata.length > 0) {
      this.dataAvailable = true;
      this.dataCount = this.otScheduledata.length;
      this.errorCount = 0;
      for (var i = 0; i < this.otScheduledata.length; i++) {
        this.errorCount += this.otScheduledata[i].error ? 1 : 0;
      }
    } else {
      this._error.next("Data not found!!");
    }
  }

  initAlert() {
    this._success.subscribe(message => (this.successMessage = message));
    this._success
      .pipe(debounceTime(2000))
      .subscribe(() => (this.successMessage = null));

    this._error.subscribe(message => (this.errorMessage = message));
    this._error
      .pipe(debounceTime(2000))
      .subscribe(() => (this.errorMessage = null));
  }

  onConfirm() {
    this.otScheduleService
      .saveOTSchedule(this.otScheduledata)
      .pipe(first())
      .subscribe((res: any) => {
        this.dataAvailable = false;
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "csrc Data Saved");
        this.router.navigate(["admin/ot-schedule-upload"]);

      });
  }

  ondocError(e: any) {
    this.error = e;
  }
}
